module.exports = __webpack_public_path__ + "static/media/video_consent_audio_malayalam.c147ad9d.mp3";